<template>
  <basic-container>
    <div class="search-contain">
      <el-form ref="query" :model="query" :inline="true" size="mini">
        <el-form-item label="活动时间" prop="daterange">
          <el-date-picker
            v-model="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input placeholder="请输入名称" v-model.trim="query.event" clearable />
        </el-form-item>
        <el-form-item label="创建人">
          <el-input placeholder="请输入" v-model.trim="query.createAt" clearable />
        </el-form-item>
        <el-form-item label="活动状态" prop="status">
          <el-select v-model="query.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchChange" :loading="loading"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="searchReset" :loading="loading"
            >清空</el-button
          >
          <el-button
            class="add"
            type="primary"
            @click="addClick"
            icon="el-icon-plus"
            style="margin-right: 40px"
            v-has-permi="['prize_edit']"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <yd-table
      :loading="loading"
      :data="records"
      border
      size="mini"
      :pagination="pagination"
      @onChange="onTableChange"
    >
      <el-table-column label="活动ID" prop="id" align="center" />
      <el-table-column label="活动名称" prop="name" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="openDetail(scope.row)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="statusType" align="center" />
      <el-table-column label="创建人" prop="createUser" align="center" />
      <el-table-column label="创建时间" prop="createTime" align="center" />
      <el-table-column label="活动时间" prop="discountsMoney" align="center">
        <template slot-scope="scope">
          <div>活动开始时间:{{ scope.row.startTime }}</div>
          <div>活动结束时间:{{ scope.row.endTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="operate" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getAdvertisingInfo(scope.row.id)"
            size="mini"
            v-if="scope.row.status !== 3"
            v-has-permi="['prize_edit']"
            >编辑</el-button
          >
          <el-button
            type="text"
            @click="handleSetPrize(scope.row)"
            size="mini"
            v-has-permi="['prize_edit']"
            v-if="scope.row.status !== 3"
            >奖品设置</el-button
          >
          <el-button
            type="text"
            @click="handleStatistics(scope.row.id)"
            size="mini"
            v-has-permi="['prize_edit']"
            >数据</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.isHavePrize"
            @click="handleVirtualList(scope.row)"
            size="mini"
            v-has-permi="['prize_edit']"
            >中奖名单</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.status === 0"
            @click="controlsStatus(scope.row, 1)"
            size="mini"
            v-has-permi="['prize_edit']"
            >上架</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.status === 1 || scope.row.status === 2"
            @click="controlsStatus(scope.row, -1)"
            size="mini"
            v-has-permi="['prize_edit']"
            >下架</el-button
          >
        </template>
      </el-table-column>
    </yd-table>
    <prize-draw-edit
      ref="drawEdit"
      v-if="editVisible"
      :visible="editVisible"
      @saveEdit="saveEdit"
      @closeEdit="closeEdit"
      :formData="advertisingInfo"
    />
    <prize-detail ref="activityDetail" @lookActive="lookActive" />
    <prize-draw-look :visibleLook="visibleLook" @closeLook="closeLook" ref="prizeLook" />
    <!-- 数据 -->
    <prize-statistics
      :visible="visibleStatistics"
      @close="closeStatistics"
      ref="statistics"
      :activityId="activityId"
    />
    <!-- 设置奖品 -->
    <set-prize
      :visible="visibleSetPrize"
      @close="closeSetPrize"
      ref="setPrize"
      :activityId="activityId"
      :activeStatus="activeStatus"
    />
    <!-- 虚拟中奖名单 -->
    <YdDialog
      title="中奖名单"
      :visible.sync="showRollCall"
      append-to-body
      @close="closeRollCall"
      width="60%"
    >
      <el-form>
        <el-form-item label="中奖名单">
          <el-radio-group v-model="form.fakeWinnerListToggle">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="2">隐藏</el-radio>
          </el-radio-group>
          <div class="flex flex-align-center margin-top-10">
            <el-button
              type="success"
              icon="el-icon-plus"
              plain
              @click="controlsPrize('add')"
              :disabled="form.fakeWinnerListToggle == 2"
              size="mini"
              >新增虚拟中奖数据</el-button
            >
            <span class="margin-left-15 font-12">完成活动奖品配置后操作添加虚拟中奖数据</span>
          </div>
          <div>
            <div
              v-for="(item, index) in virtualList"
              :key="index"
              class="flex flex-align-center font-12 margin-top-10"
            >
              <div class="margin-right-15">记录{{ index + 1 }}：</div>
              <div>用户手机号：</div>
              <el-input
                v-model.trim="item.userPhone"
                placeholder="请输入手机号"
                style="width: 200px"
                class="margin-right-15"
                size="mini"
                :maxlength="11"
              />
              <div>中奖奖品：</div>
              <el-select
                v-model="item.prizesId"
                size="mini"
                placeholder="请选择奖品"
                class="margin-right-15"
              >
                <el-option
                  v-for="item in prizeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-button type="danger" @click="controlsPrize('del', index)" size="mini"
                >删除</el-button
              >
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRollCall">取 消</el-button>
        <el-button type="primary" @click="saveRollCall" :loading="saveLoading">保 存</el-button>
      </div>
    </YdDialog>
  </basic-container>
</template>

<script>
  import {
    rafflePage,
    raffleDetail,
    fakeWinner,
    activePrizeList,
    activeStatus
  } from '@/api/marketing/prize-draw'
  import prizeDrawEdit from './components/prize-draw-edit'
  import prizeDetail from './components/prize-detail'
  import prizeStatistics from './components/prize-statistics'
  import setPrize from './components/set-prize'
  import prizeDrawLook from './components/prize-draw-look'
  import { mapState } from 'vuex'
  import dayjs from 'dayjs'
  import isBetween from 'dayjs/plugin/isBetween'
  import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
  import { isMobile } from '@/util/validate'

  export default {
    name: 'prizeDraw',
    components: {
      prizeDrawEdit,
      prizeDetail,
      prizeStatistics,
      setPrize,
      prizeDrawLook
    },
    data() {
      return {
        statusList: [
          { value: 0, label: '待上架' },
          { value: 1, label: '未开始' },
          { value: 2, label: '进行中' },
          { value: 3, label: '已结束' },
          { value: -1, label: '已下架' }
        ],
        query: {},
        daterange: [],
        // 分页
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        records: [],
        editVisible: false,
        advertisingInfo: {},
        dataVisible: false,
        loading: false,
        visibleLook: false,
        visibleStatistics: false, // 数据弹框显隐
        visibleSetPrize: false, // 设置奖品弹框
        activityId: '', // 活动id
        showVisible: false,
        form: {
          fakeWinnerListToggle: 1
        },
        showRollCall: false,
        virtualList: [],
        prizeList: [],
        saveLoading: false,
        activeStatus: ''
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.user.userInfo
      })
    },
    created() {
      dayjs.extend(isSameOrAfter)
      dayjs.extend(isBetween)
    },
    mounted() {
      // this.initPage()
    },
    methods: {
      onTableChange({ current, pageSize }) {
        // 页面切换
        this.pagination.current = current
        this.pagination.pageSize = pageSize
        this.initPage()
      },
      initPage() {
        // 初始化页面
        let startTime = ''
        let endTime = ''
        if (this.daterange && this.daterange.length !== 0) {
          startTime = this.daterange[0] + ' 00:00:00'
          endTime = this.daterange[1] + ' 23:59:59'
        }
        const params = {
          startTime,
          endTime,
          ...this.pagination,
          ...this.query,
          type: 4,
          size: this.pagination.pageSize
        }
        this.getReceivePageFetch(params)
      },
      addClick() {
        // 新增活动
        this.editVisible = true
      },
      saveEdit() {
        // 保存活动
        this.closeEdit()
        this.initPage()
      },
      closeEdit() {
        // 关闭
        this.advertisingInfo = {}
        this.editVisible = false
      },
      closeLook() {
        // 预览关闭
        this.visibleLook = false
      },
      closeStatistics() {
        // 数据弹框关闭
        this.visibleStatistics = false
      },
      searchChange() {
        // 搜索
        // this.pagination = {
        //   current: 1,
        //   pageSize: 10,
        //   total: 0
        // }
        this.pagination.current = 1
        this.initPage()
      },
      searchReset() {
        // 清空
        this.daterange = []
        this.query = {}
        this.pagination = {
          current: 1,
          pageSize: 10,
          total: 0
        }
        this.initPage()
      },
      dataView(obj) {
        this.$refs.dataView.init(obj.id, obj.name)
      },
      openDetail(obj) {
        this.$refs.activityDetail.init(obj.id)
      },
      // 获取抽奖活动分页
      getReceivePageFetch(params) {
        this.loading = true
        rafflePage(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.records = data.records
              this.total = data.total
              this.pagination.total = data.total
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getAdvertisingInfo(id) {
        // 点击编辑获取活动详情数据
        this.$loading()
        raffleDetail(id)
          .then((res) => {
            const { data, code } = res
            if (code === 0) {
              data.images = data.images ? [{ url: data.images }] : []
              data.shareImages = data.shareImages ? [{ url: data.shareImages }] : []
              data.conditions = data.conditions && JSON.parse(data.conditions)
              this.advertisingInfo = { ...data, ...data.conditions }
              this.editVisible = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      lookActive(id) {
        // 预览
        this.$refs.prizeLook.init(id)
        this.visibleLook = true
      },
      handleStatistics(id) {
        // 显示数据弹框
        this.activityId = id
        this.$refs.statistics.init()
        this.visibleStatistics = true
      },
      handleSetPrize(row) {
        // 奖品设置
        this.activeStatus = row.status
        this.activityId = row.id
        this.visibleSetPrize = true
        this.$refs.setPrize.initPage(row.id)
      },
      closeSetPrize() {
        // 关闭奖品设置弹框
        this.visibleSetPrize = false
      },
      handleVirtualList(row) {
        // 显示虚拟名单弹框
        this.form.activeId = row.id
        this.showRollCall = true
        this.virtualList = JSON.parse(JSON.stringify(row.fakeList))
        this.form.fakeWinnerListToggle = row.fakeWinnerListToggle
        this.getPrizeList(row.id)
      },
      controlsPrize(type, index) {
        // 添加/删除虚拟奖品
        if (type === 'add') {
          this.virtualList.push({
            userPhone: '',
            prizesId: ''
          })
        } else {
          this.$confirm('是否删除该数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.virtualList.splice(index, 1)
          })
        }
      },
      closeRollCall() {
        // 关闭设置虚拟中奖名单
        this.form = {
          fakeWinnerListToggle: 1
        }
        this.virtualList = []
        this.showRollCall = false
      },
      saveRollCall() {
        // 虚拟中奖名单保存
        if (this.virtualList.length) {
          const fakeObj = this.virtualList.filter((item) => !(item.userPhone && item.prizesId))
          if (fakeObj.length) {
            this.$message.warning('请填写完整虚拟中奖数据')
            return
          }
          const isPhone = this.virtualList.filter((item) => !isMobile(item.userPhone))
          if (isPhone.length) {
            this.$message.warning('虚拟中奖数据手机号有误')
            return
          }
        }
        const params = {
          id: this.form.activeId,
          show: this.form.fakeWinnerListToggle,
          fakeList: this.virtualList || []
        }
        this.saveLoading = true
        fakeWinner(params).then((res) => {
          if (res.code) return
          this.showRollCall = false
          this.saveLoading = false
          this.initPage()
        })
      },
      getPrizeList(id) {
        // 获取奖品列表
        activePrizeList(id).then((res) => {
          if (res.code) return
          res.data.forEach((item) => {
            item.label = item.prizeName
            item.value = item.prizesId
          })
          this.prizeList = res.data
        })
      },
      controlsStatus(row, status) {
        const params = {
          id: row.id,
          status
        }
        this.$confirm(
          `${status === 1 ? '是否上架该活动?' : '下架后乘客端不再展示该活动且无法再次上架'}`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }
        ).then(() => {
          activeStatus(params).then((res) => {
            if (res.code) return
            this.$message.success(`${status === 1 ? '上架' : '下架'}成功`)
            this.initPage()
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
